import { Injectable } from '@angular/core';
import { AppConstants } from 'apps/console/src/app/app.constants';

@Injectable({
	providedIn: 'root'
})
export class PostLoginRouteService {

	hasPostLoginRoute() {
		return !!this.getPostLoginRoute();
	}

	getPostLoginRoute() {
		return localStorage.getItem(AppConstants.LOCALSTORAGE_KEYS.POST_LOGIN_ROUTE);
	}

	savePostLoginRoute(route: string) {
		localStorage.setItem(AppConstants.LOCALSTORAGE_KEYS.POST_LOGIN_ROUTE, route);
	}

	removePostLoginRoute() {
		localStorage.removeItem(AppConstants.LOCALSTORAGE_KEYS.POST_LOGIN_ROUTE);
	}
}
